import axios from "axios";
import { t, locale } from "@/i18n";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("nv_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || t("Qualcosa è andato storto. Riprova.");
  if (typeof detail === "string") return t(detail);
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}

export const STATUS = {
  assegnato: { label: "Nuovo ordine", color: "#4accff" },
  accettato: { label: "Accettato", color: "#4accff" },
  carico: { label: "Carico in corso", color: "#3b82f6" },
  in_viaggio: { label: "Viaggio in corso", color: "#10b981" },
  pausa: { label: "In pausa", color: "#f59e0b" },
  arrivato: { label: "Arrivato", color: "#ef0298" },
};

export const ACTIVE = ["in_viaggio", "pausa", "carico", "accettato"];

export function pickActive(trips) {
  for (const s of ACTIVE) {
    const t = trips.find((x) => x.status === s);
    if (t) return t;
  }
  return null;
}

export const fmtTime = (iso) =>
  new Date(iso).toLocaleString(locale(), { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const fmtDur = (sec) => {
  const s = Math.max(0, Math.round(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h}h ${String(m).padStart(2, "0")}m`;
};

export const fmtClock = (sec) => {
  const s = Math.max(0, Math.round(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
};

export const fmtKm = (m) => (m >= 1000 ? `${(m / 1000).toFixed(m >= 10000 ? 0 : 1)} km` : `${Math.round(m / 10) * 10} m`);

export function haversineKm(a, b) {
  const r = (x) => (x * Math.PI) / 180;
  const dLat = r(b[0] - a[0]);
  const dLng = r(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(r(a[0])) * Math.cos(r(b[0])) * Math.sin(dLng / 2) ** 2;
  return 6371 * 2 * Math.asin(Math.sqrt(h));
}

export function getSavedPos() {
  try {
    return JSON.parse(localStorage.getItem("nv_pos"));
  } catch {
    return null;
  }
}

export const savePos = (p) => localStorage.setItem("nv_pos", JSON.stringify(p));
